import { Button } from '@wot/components';
import { useState } from 'react';
import { MdClose } from 'react-icons/md';
import BottomSheet from '../../components/Bottomsheet';
import { LPlan } from '../../interfaces/Plan';

function ChangeRequest({
  setShowChangeRequest,
  onChangeTutorRequest
}: {
  plan: LPlan;
  setShowChangeRequest: any;
  onChangeTutorRequest: (reason: string) => Promise<boolean>;
}) {
  const [reason, setReason] = useState<string>('');
  const [loading, setLoading] = useState(false);

  const changeTutorRequest = () => {
    setLoading(true);
    onChangeTutorRequest(reason)
      .then(() => setLoading(false))
      .catch(() => setLoading(false));
  };

  return (
    <BottomSheet height={50}>
      <div className="w-full h-full mt-4 p-5 flex flex-col items-center">
        <div className="w-full flex justify-between">
          <div />
          <h1 className="w-full mx-auto text-base md:text-xl text-center font-semibold">Request for tutor change</h1>
          <MdClose className="right-0 text-2xl cursor-pointer ml-auto" onClick={() => setShowChangeRequest(false)} />
        </div>
        <div className="w-full h-[80%] p-6">
          <textarea
            placeholder="Write your reason"
            className={`w-full h-full resize-none outline-none focus:outline-1 disabled:outline-gray-300 focus:outline-blue-300 bg-neutralBlue2 px-4 py-2 rounded-md cursor-text
              `}
            value={reason}
            onChange={(e) => {
              setReason(e.target.value);
            }}
          ></textarea>
        </div>
        <div className="w-12">
          <Button
            loading={loading}
            disabled={reason.length === 0}
            type="primary"
            text={'Submit'}
            onClick={() => changeTutorRequest()}
          />
        </div>
      </div>
    </BottomSheet>
  );
}

export default ChangeRequest;
